import React, { useState } from 'react';
import Header from '../components/Header';
import LocationTabs from '../components/LocationTabs';
import GoldenLightsBackground from '../components/GoldenLightsBackground';

const Index = () => {
  const [activeLocation, setActiveLocation] = useState<'puerto-la-cruz' | 'margarita'>('puerto-la-cruz');
  
  return (
    <div className="min-h-screen bg-dark text-white relative overflow-hidden">
      <GoldenLightsBackground />
      <div className="container mx-auto px-4 py-8 relative z-10">
        <Header />
        
        <LocationTabs 
          activeLocation={activeLocation} 
          onLocationChange={setActiveLocation} 
        />
        
        <div className="mt-12 p-8 bg-dark-lighter rounded-lg gold-border text-center relative overflow-hidden">
          {/* Efectos de decoración */}
          <div className="absolute -top-10 -left-10 w-40 h-40 bg-gold/5 rounded-full blur-3xl animate-float"></div>
          <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-gold/5 rounded-full blur-3xl animate-float delay-1000"></div>
          
          {/* Estrella decorativa superior */}
          <div className="text-4xl mb-2">✨</div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-6 gold-gradient animate-glow">
            ¡Felicidades!
          </h2>
          <p className="text-xl md:text-2xl mb-6 text-white">
            Hemos culminado los 21 días de ayuno correspondiente
          </p>
          <div className="w-32 h-1 bg-gradient-to-r from-gold-dark via-gold to-gold-light mx-auto rounded-full opacity-70 mb-6"></div>
          <p className="text-2xl md:text-3xl font-bold gold-gradient animate-pulse-slow">
            ¡Inicia nuestra temporada de gloria y de poder!
          </p>
          
          {/* Estrella decorativa inferior */}
          <div className="text-4xl mt-4">✨</div>
        </div>
      </div>
    </div>
  );
};

export default Index;
